export default __webpack_public_path__ + "static/media/empty-state.ad60129d.png";